import React, {createContext, Dispatch, useReducer} from "react";

export enum SharedContextActionType {
    unsavedChange,
}

interface SharedContextAction {
    type: SharedContextActionType,
    state?: any
}

interface SharedContextState {
    hasUnSavedChanges?: boolean,
    [x: string]: any
}

const initialSharedContextState: SharedContextState = {
    hasUnSavedChanges: false,
}

function reducer(shareState: SharedContextState, action: SharedContextAction ) {
    if (!action) {
        return shareState
    }
    const { type, state } = action
    switch (type) {
    case SharedContextActionType.unsavedChange:
        return {
            ...shareState,
            hasUnSavedChanges: state,
        }
    default:
        return shareState
    }
}

export const SharedContext = createContext<{
    sharedContextState: SharedContextState,
    dispatchSharedContext: Dispatch<SharedContextAction>,
}>({
    sharedContextState: initialSharedContextState,
    dispatchSharedContext: () => null,
})

export function SharedContextProvider({children}: any) {
    const [sharedContextState, dispatchSharedContext] = useReducer(reducer, initialSharedContextState)
    return <SharedContext.Provider value={{sharedContextState, dispatchSharedContext}}>
        {children}
    </SharedContext.Provider>
}